import { render, staticRenderFns } from "./BaseLoader4.vue?vue&type=template&id=5c5b9b1f&scoped=true&"
import script from "./BaseLoader4.vue?vue&type=script&lang=js&"
export * from "./BaseLoader4.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoader4.vue?vue&type=style&index=0&id=5c5b9b1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5b9b1f",
  null
  
)

export default component.exports